import { render, staticRenderFns } from "./Layout.vue?vue&type=template&id=2fd4c912&"
import script from "./Layout.vue?vue&type=script&lang=js&"
export * from "./Layout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VMessages } from 'vuetify/lib/components/VMessages';
import { VSlideYReverseTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VMessages,VSlideYReverseTransition})
